//该文件专门用于创建整个应用的路由器
import VueRouter from "vue-router";
// import Login from '../pages/Login'
// import Home from '../pages/Home'
//创建并暴露一个路由器
export default new VueRouter({
    routes:[
        {
            path:'/',
            redirect:'/login'
        },
        {
            path:'/login',
           component: () => import('../pages/Login'),
            name:'Login'
        },
        {
            path:'/home',
           component: () => import('../pages/Home'),
            name:'Home'
        }, {
            path: '/control',
            component: () => import('../pages/Control'),
            name: 'Control'
        }, {
            path: '/usermanage',
            component: () => import('../pages/UserManage'),
            name: 'UserManage'
        },{
            path: '/settings',
            component: () => import('../pages/Settings'),
            name: 'Settings'
        }
    ]
})